export default __webpack_public_path__ + "static/media/img_publi4.06d39c53.svg";